import { useRoutes } from 'react-router-dom';
import NotFound from 'components/pages/SinglePages/Error/NotFound';
import activationRoutes from './activation.routes';
import authRoutes from './auth.routes';
import diagRoutes from './diag.routes';
import monitoringRoutes from './monitoring.routes';
import periodicMaintenanceRoutes from './periodic-maintenance.routes';
import profileRoutes from './profile.routes';
import reminderRoutes from './reminder.routes';
import robotRoutes from './robot.routes';
import singlePageRoutes from './singlepage.routes';
import vehicleRoutes from './vehicle.routes';
import publicSinglePageRoutes from './public-singlepage.routes';
import antiTheftRoutes from './anti-theft.routes';
import mapAlarmRoutes from './map-alarm';

export default function RoutesIndex() {
  const element = useRoutes([
    ...activationRoutes,
    ...authRoutes,
    ...diagRoutes,
    ...monitoringRoutes,
    ...periodicMaintenanceRoutes,
    ...profileRoutes,
    ...reminderRoutes,
    ...robotRoutes,
    ...singlePageRoutes,
    ...vehicleRoutes,
    ...publicSinglePageRoutes,
    ...antiTheftRoutes,
    ...mapAlarmRoutes,
    { path: '/not-found', element: <NotFound /> },
    { path: '*', element: <NotFound /> },
  ]);

  return element;
}
